import { useCallback, useEffect, useMemo, useState } from "react";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import ModalConfirmacao2 from "../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalHistoricoEdicao from "../../../components/ModalHistoricoEdicao/ModalHistoricoEdicao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import { useTabela } from "../../../contexts/Tabela.js";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import useService from "../../../hooks/useService.ts";
import { Embarque } from "../../../models/Embarque.ts";
import { getHistoricoEmbarque } from "../../../services/ModuloGerenciador/Embarque.js";
import {
	buscarViagensDeletadas,
	reativarViagemDeletadas,
} from "../../../services/ModuloGerenciador/Viagens.ts";
import "./ViagensDeletadas.css";

function ViagensDeletadas() {
	const [semAutorizacao, setSemAutorizacao] = useState(false);
	const [viagensDeletadas, setViagensDeletadas] = useState<Embarque[]>([]);
	const [historicoEmbarque, setHistoricoEmbarque] = useState<any>(null);
	const [openModalHistoricoEdicao, setOpenHistoricoEdicao] = useState(false);
	const [openModalUsuario, setOpenUsuario] = useState(false);
	const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
	const [textoErro, setTextoErro] = useState("");
	const [textoSucesso, setTextoSucesso] = useState("");
	const [openToastErro, setOpenToastErro] = useState(false);
	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const { profile, hasRegra, tabelaUsuario } = useProfile();
	const { tabelaRedux } = useTabela();

	const [isLoadingViagensDeletadas, buscarViagens] = useService(
		() => buscarViagensDeletadas({ token: profile?.token || "" }),
		{
			autoStart: false,
			onData: (response) => {
				setViagensDeletadas(response.data);
			},
		}
	);

	const [, buscarHistoricoEmbarque] = useService(
		(embarcagemHistoricoId: string) =>
			getHistoricoEmbarque(embarcagemHistoricoId, profile?.token || ""),
		{
			autoStart: false,
			onData: (response) => {
				setHistoricoEmbarque(response.data);
				setOpenHistoricoEdicao(true);
			},
			onError: (error) => {
				setTextoErro(
					error.response.data || "Erro ao buscar histórico de embarque"
				);
				setOpenToastErro(true);
			},
		}
	);

	const [, reativarViagem] = useService(
		(id: string) =>
			reativarViagemDeletadas({ token: profile?.token || "", id }),
		{
			autoStart: false,
			onData: () => {
				setTextoSucesso("Viagem reativada com sucesso!");
				setOpenToastSucesso(true);
				buscarViagens();
			},
			onError: (error) => {
				setTextoErro(error.response.data || "Erro ao reativar viagem");
				setOpenToastErro(true);
			},
		}
	);

	const handleCloseToastErro = useCallback(() => {
		setOpenToastErro(false);
	}, []);

	const handleCloseToastSucesso = useCallback(() => {
		setOpenToastSucesso(false);
	}, []);

	const handleCloseUsuario = useCallback(() => {
		setOpenUsuario(false);
	}, []);

	const handleCloseModalConfirmacao = useCallback(() => {
		setOpenModalConfirmacao(false);
	}, []);

	const handleReativarViagem = useCallback(() => {
		if (!!tabelaRedux?.row?.idEmbarque) {
			reativarViagem(tabelaRedux.row.idEmbarque);
		}
	}, [tabelaRedux?.row?.idEmbarque]);

	const handleBuscarHistoricoEmbarque = useCallback(() => {
		if (!!tabelaRedux?.row?.embarqueHistoricoId) {
			buscarHistoricoEmbarque(tabelaRedux?.row.embarqueHistoricoId);
		} else if (!!tabelaRedux?.row) {
			setTextoErro("Coluna sem histórico");
			setOpenToastErro(true);
		} else {
			setTextoErro("Selecione uma coluna com histórico");
			setOpenToastErro(true);
		}
	}, [tabelaRedux?.row?.embarqueHistoricoId, buscarHistoricoEmbarque]);

	const handleCloseHistoricoStatus = useCallback(() => {
		setOpenHistoricoEdicao(false);
	}, []);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Viagens Deletadas"));
			buscarViagens();
		}
	}, [profile?.token]);

	const isLoading = useMemo(() => {
		return !profile?.token || isLoadingViagensDeletadas || !viagensDeletadas;
	}, [profile?.token, isLoadingViagensDeletadas]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title="Viagens Deletadas">
			<MotionContainer>
				<div className="content-container">
					<Separator size="xl" />
					<TabelaV2
						classeSelecionado="idEmbarque"
						nomeClasse1="outer-wrapper-v2"
						nomeClasse2="table-v2"
						colunas={tabelaUsuario?.Embarque}
						dados={viagensDeletadas}
						nome="embarque"
						nomeTable="Embarque"
						numeroEmbarque={viagensDeletadas.length}
						isLoading={isLoading}
					/>
					<Separator size="xl" />
				</div>
				{viagensDeletadas.length > 0 && (
					<div className="footer-space-between">
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							icone="iconeCheck"
							titulo="Reativar Viagem"
							onClick={() => {
								if (!!tabelaRedux.row && !!tabelaRedux.colunaSelecionada) {
									setOpenModalConfirmacao(true);
								} else {
									setTextoErro("Selecione uma viagem para reativar.");
									setOpenToastErro(true);
								}
							}}
						/>
						<div>
							<CustomButtonV2
								classCss="custom-button-user"
								classText="button-texto-user"
								titulo="Obter Usuário"
								cor="#FFFFFF"
								disabled={isLoadingViagensDeletadas}
								onClick={() => {
									if (tabelaRedux.usuarioAlteracao) {
										setOpenUsuario(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-historico"
								classText="button-texto-user"
								titulo="Histórico"
								cor="#FFFFFF"
								disabled={isLoadingViagensDeletadas}
								onClick={handleBuscarHistoricoEmbarque}
							/>
						</div>
					</div>
				)}
			</MotionContainer>

			<ModalHistoricoEdicao
				valueTabela={tabelaRedux}
				titulo="Histórico"
				open={openModalHistoricoEdicao}
				onClose={handleCloseHistoricoStatus}
				valueDados={historicoEmbarque}
				classeSelecionado="idEmbarque"
				nome="embarque"
				colunas="Embarque"
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openModalUsuario}
				onClose={handleCloseUsuario}
			/>
			<ModalConfirmacao2
				titulo="Reativar Viagem"
				texto="Deseja reativar viagem?"
				textoBotao="Sim"
				open={openModalConfirmacao}
				onClose={handleCloseModalConfirmacao}
				onClick={handleReativarViagem}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
		</Layout>
	);
}

export default ViagensDeletadas;
